import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/sl'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import RoutesAndMenuBuilder from './assets/js/menuAndRoutesBuilder'
import PermissionHelper from './assets/js/Permissions/permissionHelper'
import Avatar from './assets/js/globalne_funkcije/PridobitevUporabniskihPodatkovGlobalno/Avatar'
// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/_index.scss'

import eventBus from 'assets/js/eventBus.js'
import VueScreen from 'vue-screen'
import sidebarLinks from './sidebarLinks'
import {Obvestilo} from './assets/js/globalne_funkcije/SplosneGlobalneFunkcije/Notification.js'
import FormValidationRules from './assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormValidationRules'
import './assets/js/Filters/dateFilters'

Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})
Vue.mixin(PermissionHelper)
Vue.use(FormValidationRules)
Vue.use(VueScreen, {
  xs: 0,
  sm: 550,
  md: 768,
  lg: 992,
  xl: 1200
})
Vue.mixin(Obvestilo)
Vue.mixin(Avatar)

window.axios = require('axios')
locale.use(lang)

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  // tule je problem ker ne zna sparsat tokena ker se ta shit požene predn gre čez avtorizacijo
  RoutesAndMenuBuilder.getInstance().CanNavigate(to.path).then((canNavigate) => {
    if (canNavigate) {
      next()
    } else {
      next('/NotFound')
    }
  }).catch(() => {
    next('/NotFound')
  })
})

/* populate new sidebar links */
eventBus.$on('SIDEBAR_LOADED', (sidebarLinks) => {
  mainApp.$sidebar = sidebarLinks
})

eventBus.$on('KRITICNI_PROCES_POPUP', (visible) => {
  mainApp.$root.kriticniProcesPopup = visible
})

/* eslint-disable no-new */
let mainApp = new Vue({
  el: '#app',
  data: {
    kriticniProcesPopup: false
  },
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js